import * as firestore from 'firebase/firestore';
import { FirebaseMessageThread } from '../types/firebase/FirebaseMessageThread';
import { FirestoreDataConverter } from 'firebase/firestore';
import { MessageThread } from '../types/MessageThread';
import { DateTime } from 'luxon';

export const messageThreadConverter: FirestoreDataConverter<MessageThread> = {
  toFirestore(messageThread: MessageThread): firestore.DocumentData {
    let data: FirebaseMessageThread = {
      id: messageThread.id,
      idNumber: messageThread.idNumber,
      name: messageThread.name,
      members: messageThread.members.map(v => {
        return {
          uid: v.employee?.uid ?? "",
          idNumber: v.employee?.idNumber ?? "",
          dateAdded: firestore.Timestamp.fromMillis(v.dateAdded.toMillis())
        }
      }),
      membersId: messageThread.membersId,
      membersMD5Hash: messageThread.membersMD5Hash,
      unreadMessagesCount: messageThread.unreadMessagesCount,
      lastUpdate: firestore.serverTimestamp()
    };
    return data;
  },
  fromFirestore(snapshot: firestore.QueryDocumentSnapshot): MessageThread {
    const data = snapshot.data() as FirebaseMessageThread;
    return {
      id: data.id,
      idNumber: data.idNumber,
      name: data.name,
      members: data.members.map(v => {
        return {
          idNumber: v.idNumber,
          employee: undefined,
          dateAdded: DateTime.fromJSDate(v.dateAdded.toDate())
        }
      }),
      membersId: data.membersId,
      membersMD5Hash: data.membersMD5Hash,
      unreadMessagesCount: data.unreadMessagesCount,
      lastUpdate: DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate())
    };
  }
}
